var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHeart = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.253 5.076c-1.932-1.651-4.777-1.335-6.568.491l-.667.703-.703-.703C9.56 3.741 6.68 3.425 4.748 5.076c-2.213 1.896-2.318 5.268-.352 7.305l6.814 7.024a1.083 1.083 0 0 0 1.58 0l6.814-7.024c1.966-2.037 1.861-5.409-.351-7.305"
})));
export default SvgHeart;